import React, { useState, useEffect, useRef } from 'react';
import { Card, Button, Container, Row, Col, Modal, Form } from 'react-bootstrap';
import styled from 'styled-components';

// Styled Components
const StyledContainer = styled(Container)`
  background-color: #232830;
  color: #ffffff;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
`;

const StyledHeading = styled.h2`
  font-size: 22px;
  font-weight: bold;
  color: #ff7c24;
  text-align: center;
  margin-bottom: 20px;
`;

const QuestionText = styled.h3`
  font-size: 20px;
  font-weight: bold;
  color: #ffffff;
  text-align: center;
  margin-bottom: 20px;
`;

const StyledCard = styled(Card)`
  background-color: ${(props) =>
    props.selected ? (props.isCorrect ? '#2ECC71' : '#FF4C4C') : '#FFFFFF'};
  color: ${(props) => (props.selected ? '#FFFFFF' : '#232830')};
  border-radius: 15px;
  padding: 15px;
  margin-bottom: 10px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
  &:hover {
    transform: scale(1.02);
  }
`;

const HelpText = styled.p`
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  margin-top: 15px;
`;

const ContinueButton = styled(Button)`
  background-color: #ff7c24;
  width: 100%;
  margin-top: 10px;
  font-size: 18px;
  font-weight: bold;
  border-radius: 10px;
  padding: 12px 30px;
  &:disabled {
    background-color: grey;
    border-color: grey;
  }
`;

const MultipleChoicePSQuestion = ({ question, onNext, maxWrongAnswersRemaining, onUpgrade }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [isCorrect, setIsCorrect] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);
  const [showHint, setShowHint] = useState(false);
  const [wrongAttempts, setWrongAttempts] = useState(0);

  useEffect(() => {
    setSelectedOption(null);
    setIsCorrect(false);
    setShowFeedback(false);
    setShowHint(false);
  }, [question]);

  const handleOptionSelect = (index) => {
    if (!showFeedback) {
      setSelectedOption(index);
      const correct = index.toString() === question.correctanswer;
      setIsCorrect(correct);
      setShowFeedback(true);
      
      if (!correct) {
        setWrongAttempts((prev) => prev + 1);
      }
    }
  };


  useEffect(() => {
    // Reset answer selection when a new question is loaded
    setSelectedOption(null);
    setIsCorrect(false);
    setShowFeedback(false);
  }, [question]); // Runs every time `question` changes

  return (
    <StyledContainer>
      <StyledHeading>Practice Session - Multiple Choice</StyledHeading>
      <QuestionText>{question.questionname}</QuestionText>

      <Row className="g-3" style={{ marginTop: '20px' }}>
        {[1, 2, 3, 4].map((index) => {
          const option = question[`answeroption${index}`];
          if (!option) return null;

          return (
            <Col xs={12} key={index}>
              <StyledCard
                onClick={() => handleOptionSelect(index)}
                selected={selectedOption === index}
                isCorrect={isCorrect}
              >
                {option}
              </StyledCard>
            </Col>
          );
        })}
      </Row>

      {showFeedback && (
        <>
          {wrongAttempts > maxWrongAnswersRemaining ? (
            <Button
              onClick={onUpgrade}
              style={{
                backgroundColor: '#FF4C4C',
                width: '100%',
                marginTop: '10px',
                fontSize: '18px',
                fontWeight: 'bold',
                borderRadius: '10px',
                padding: '12px 30px',
              }}
            >
              Upgrade to Unlock More Practice
            </Button>
          ) : (
            <ContinueButton onClick={() => {
                //console.log("✅ Continue button clicked in MultipleChoicePSQuestion");
                onNext();
            }}>
                Continue
            </ContinueButton>
            
          )}
        </>
      )}

      {showHint && <HelpText>{question.help || 'No hint available.'}</HelpText>}

      <Button
        onClick={() => setShowHint(true)}
        style={{
          backgroundColor: '#007bff',
          marginTop: '10px',
          fontSize: '16px',
          fontWeight: 'bold',
        }}
      >
        Need a Hint?
      </Button>
    </StyledContainer>
  );
};

export default MultipleChoicePSQuestion;
